import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PostTemplateForm from "./PostTemplateForm";
import FullPageLoader from "../../common/FullPageLoader";
import { addPostTemplateApi } from "../../api/postTemplateService";
/* ---------- DATE FORMAT ---------- */
const formatDateForInput = (isoString) => {
  if (!isoString) return "";
  return new Date(isoString).toISOString().split("T")[0];
};
const AddPostTemplate = () => {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [apiErrors, setApiErrors] = useState({});
  /* ---------- ADD TEMPLATE ---------- */
  const handleSubmit = async (payload, setErrors) => {
    setSaving(true);
    setMessage("");
    setApiErrors({});
    try {
      /*
       * Request body
       */
      const requestBody = {
        name: payload.name,
        fromDate: payload.fromDate,
        toDate: payload.toDate,
        status: payload.status,
        orderId: Number(payload.orderId),
        categoryId: payload.categoryId,
        description: payload.description,
        link: payload.link,
        image: payload.image,
      };
      const response = await addPostTemplateApi(requestBody);
      /* ---------- VALIDATION ERROR ---------- */
      if (response?.error && typeof response.error === "object") {
        setApiErrors(response.error);
        setErrors(response.error);
        return;
      }
      /* ---------- SUCCESS ---------- */
      if (response?.success) {
        navigate("/banner-template", {
          state: {
            toastMessage: response?.message || "Banner Template added successfully!",
            toastType: "success",
          },
        });
        return;
      }
      /* ---------- API MESSAGE ---------- */
      setMessage(response?.message || "Failed to add Banner Template.");
    } catch (error) {
      console.error("Add Banner Template Error:", error);
      const responseData = error?.response?.data;
      /* ---------- 422 VALIDATION ---------- */
      if (error?.response?.status === 422) {
        const backendErrors = responseData?.error || responseData?.errors || {};
        if (typeof backendErrors === "object") {
          setApiErrors(backendErrors);
          setErrors(backendErrors);
        } else {
          setMessage(responseData?.message || "Validation failed");
        }
      } else {
        setMessage(responseData?.message || "Something went wrong. Please try again.");
      }
    } finally {
      setSaving(false);
    }
  };
  return (
    <>
      {saving && <FullPageLoader />}
      <PostTemplateForm
        initialValues={{
          name: "",
          fromDate: formatDateForInput(new Date().toISOString()),
          toDate: formatDateForInput(new Date().toISOString()),
          categoryId: "",
          status: "ACTIVE",
          orderId: "",
          description: "",
          link: "",
          image: "",
        }}
        onSubmit={handleSubmit}
        loading={saving}
        message={message}
        apiErrors={apiErrors}
        isEdit={false}
        onCancel={() => navigate("/banner-template")}
      />
    </>
  );
};
export default AddPostTemplate;
